// extracted by mini-css-extract-plugin
export default {"wrapperSizeButtons":"Q4de26gn","button":"e0oBfOir","down":"KNZKq63Z","up":"KFLIOgj4"};